// extracted by css-extract-rspack-plugin
export default {"pillBar":"pill-bar-module__pillBar___HsB5e"};